import React from 'react'
import UserNotifications from '../user/user-dashboard/user-notifications';

// The same page as the masjid users', with the admin's notifications.
export default function AdminNotifications() {
    return <UserNotifications isAdmin />;
}
